export enum ProposalTemplatesPermission {
  FullAccess = 'full_access',
  ContentEditing = 'content_editing',
  TemplatesUsage = 'templates_usage',
}
